import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'
import LinePlaneFlyIcon from 'LuxKit/Icons/line/LinePlaneFlyIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { useAirlineByCode } from 'tripPlanner/hooks/api/flights'
import type { FlightItem } from 'tripPlanner/types/tripItem'
import { addSpaceToFlightNumber } from 'tripPlanner/utils/flights'

const Logo = styled.img`
  height: ${rem(24)};
`

interface Props {
  item: FlightItem
  className?: string
}

function FlightItemCardFlightName(props: Props) {
  const { item, className } = props
  const intl = useIntl()
  const { airlineName, flightNumber } = item

  // Using 'airlineCode' to reliably lookup airline images since some
  // airline names returned by api.flightstats.com doesn't always map to an airline in svc-flights
  const { data: airline } = useAirlineByCode({
    code: item.flightNumber?.slice(0, 2),
  })

  const airlineLogo = airline?.airlineLogo
  const icon = airlineLogo ? (
    <Logo src={airlineLogo} />
  ) : (
    <LinePlaneFlyIcon size="XS" />
  )

  const sep = intl.formatMessage(middleDotSeparatorMessage)
  const details = [airlineName, addSpaceToFlightNumber(flightNumber)]
    .filter(Boolean)
    .join(` ${sep} `)
  return (
    <BodyTextBlock variant="small" className={className} startIcon={icon}>
      {details || intl.formatMessage({
        id: 'fSv0-eiuLZVTkk1_Yvsl',
        defaultMessage: 'Flight',
        description: 'Fallback text displayed when flight details are unavailable',
      })}
    </BodyTextBlock>
  )
}

export default FlightItemCardFlightName
